<template>
    <!-- <Transition name="modal">
        <div v-if="show">
            <div class="modal-mask" @click="$emit('close')" @keydown="onKeyDown($event)"></div>
            <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">default header</slot>
                </div>

                <div class="modal-body">
                    <slot name="body">
                        default body<br />
                        default body<br />
                        default body<br />

                        <component
                    :mainref="mainref"
                    v-if="dynamicModal"
                    :is="dynamicModal"
                    :data="data"
                ></component>

                    </slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer">
                        default footer
                        <button
                            class="btn btn-primary modal-default-button"
                            @click="$emit('close')"
                        >
                            OK
                        </button>
                    </slot>
                </div>
            </div>
        </div> -->


        <Dialog
            ref="dialogref"
            v-bind:visible="show"
            :maximizable="true"
            modal="modal"
            :dismissableMask="data.dismiss !== undefined && data.dismiss == false ? data.dismiss : true"
            :closeOnEscape="data.closeOnEscape !== undefined && data.closeOnEscape == false
                ? data.closeOnEscape
                : true"
            :style="`width: ${width || 50}vw;`"
            @show="$emit('open')"
            @hide="$emit('close')"
        >

            <template #header>
                <div class="d-flex flex-column fw-bold">
                    <div
                        class="fs-5 fw-bold"
                        v-html="
                            title !== undefined
                                ? title
                                : ''
                        "
                    ></div>
                    <div
                        class="text-secondary"
                        v-html="
                            subTitle !== undefined
                                ? subTitle
                                : ''
                        "
                    ></div>
                </div>
            </template>

            <!-- <slot name="body">default body</slot> -->
            <div class="max-h-100">
                <component
                    :mainref="mainref"
                    v-if="dynamicModal"
                    :is="dynamicModal"
                    :data="data"
                ></component>
            </div>

            <template #footer>
                <DAToolbar :mainref="mainref" :data="toolbar" />
            </template>

        </Dialog>

    <!-- </Transition> -->
</template>


<script>
// const props = defineProps({
//     show: Boolean,
// });
import { ref, watchEffect, computed, defineAsyncComponent } from 'vue';

import { useModelWrapper } from "@/utils/modelWrapper";

import Dialog from 'primevue/dialog';
import DAToolbar from '@/components/toolbar/DAToolbar';


export default {
    name: 'SecondModal',
    props: {
        title: String,
        subTitle: String,
        show: Boolean,
        width: Number,
        toolbar: {
            type: Object,
            default(){
                return {};
            }
        },
        data: {
            type: Object,
            default(){
                return null;
            }
        },
        mainref: {
            type: Object,
            default(){
                return null;
            }
        },
    },
    components:{
        Dialog,
        DAToolbar,
    },
    setup(props, {emit}) {
        const dialogref = ref({});
        const dpage = ref(null);

        const PO = useModelWrapper(props, emit, "mainref");

        dpage.value = props.data.page || undefined;

        watchEffect(() => {
            PO.value['modalData'] = dialogref.value;
        });

        const onKeyDown = (event) => {
            console.log(event);
            // if( event.which )
            // emit.close();
        };

        const dynamicModal = computed(() => {
            if (dpage.value) {
                return defineAsyncComponent({
                    loader: () => import(`@/${dpage.value}`),
                    loadingComponent:
                        '<center><i class="fa fa-sync fa-spin"></i></center>',
                    errorComponent: defineAsyncComponent(() =>
                        import("@/system_modules/NotFound")
                    ),
                    // timeout: 3000,
                    // suspensible: false,
                });
            } else {
                // return import("@/system_modules/NotFound");
                return defineAsyncComponent({
                    loader: () => import("@/system_modules/NotFound")
                });
            }
        });

        return {
            dialogref,
            dynamicModal,
            onKeyDown,
        };
    },
}
</script>


<style>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        transition: opacity 0.3s ease;
    }

    .modal-container {
        position: absolute;
        top: 50%;
        left: 50%;
        /* margin-right: -50%; */
        transform: translate(-50%, -50%);

        z-index: 9999;

        /* display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column; */

        /* display: flex; */
        /* align-items: center;
        justify-content: center; */

        width: 50vw;
        margin: auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
    }

    /* .modal-header {
        padding: 0px;
        margin-top: 0;
        color: #42b983;
    }

    .modal-footer{
        padding: 5px 0;
    }

    .modal-body {
        margin: 20px 0;
        max-height: calc(100vh - 300px);
        overflow: hidden;
        overflow-y: auto;
    } */

    /* .modal-default-button {
        float: right;
    } */

    /*
         * The following styles are auto-applied to elements with
         * transition="modal" when their visibility is toggled
         * by Vue.js.
         *
         * You can easily play with the modal transition by editing
         * these styles.
         */

    .modal-enter-from {
        opacity: 0;
    }

    .modal-leave-to {
        opacity: 0;
    }

    .modal-enter-from .modal-container,
    .modal-leave-to .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* .modal-enter-active {
            animation: modal-in 0.5s;
        }
        .modal-leave-active {
            animation: modal-in 0.5s reverse;
        }
        @keyframes modal-in {
            0% {
                transform: scale(0);
            }
            50% {
                transform: scale(1.25);
            }
            100% {
                transform: scale(1);
            }
        }
    */
</style>